import React, { useContext, useEffect, useState } from 'react';
import { ModalContext } from '../Modal/modalContext';
import styles from './WishlistModal.module.scss';
import { PrintButton } from '../Printer/PrintButton';
import { hasWishlistItems } from '../../functions';
import { DataContext } from '../../views/pages/Root';

export default function WishlistModal() {
  const data = useContext(DataContext);
  let { handleModal } = useContext(ModalContext);
  const [wishlistStaticData, setWishlistStaticData] = useState();
  const [isWishlistEmpty, setIsWishlistEmpty] = useState(true);

  useEffect((_) => {
    if (isWishlistEmpty) setIsWishlistEmpty(!hasWishlistItems());

    const localStorageSetHandler = () => {
      if (isWishlistEmpty) setIsWishlistEmpty(!hasWishlistItems());
    };

    document.addEventListener('itemInserted', localStorageSetHandler, false);
    return (_) => {
      document.removeEventListener('itemInserted', localStorageSetHandler, false);
    };
  }, []);

  useEffect((_) => {
    setWishlistStaticData(data?.staticData?.find((prop) => prop.name == 'wishlist'));
  }, []);

  return (
    <div id="#wishlist-modal" className={styles.wishlist_modal} onClick={() => handleModal()}>
      <div className={styles.inner_wrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.headingWrapper}>
          <div className={styles.headContent}>
            <h2 className={styles.headTitle}>{!!wishlistStaticData?.title ? wishlistStaticData.title : 'Lista życzeń'}</h2>
            {isWishlistEmpty
              ? 'Poznaj nasz katalog i dodaj produkty do listy życzeń'
              : !!wishlistStaticData?.description && <p className={styles.headDesc}>{wishlistStaticData.description}</p>}
            <button className={styles.btnClose} onClick={() => handleModal()}>
              <span className={styles.btnCloseImg}></span>
            </button>
          </div>
        </div>
        <div className={styles.boxBtnPrint}>
          <PrintButton isWishlistEmpty={isWishlistEmpty} />
        </div>
      </div>
    </div>
  );
}
